import { render, staticRenderFns } from "./SolRestaurante.vue?vue&type=template&id=31d648d6&scoped=true&"
import script from "./SolRestaurante.vue?vue&type=script&lang=js&"
export * from "./SolRestaurante.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d648d6",
  null
  
)

export default component.exports